import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import { FilterParam } from './FilterBar.types'

// Cross-domain filters require access to the objects whose names they offer.
// Local predicates (status, dates, sort order, etc.) only change the current page's
// query and deliberately have no extra capability. Clear filters is always available.
export const FILTER_REQUIRED_CAPABILITIES: Partial<
  Record<FilterParam, CAPABILITY[]>
> = {
  [FilterParam.POLICY]: [CAPABILITY.CAN_VIEW_POLICIES],
  [FilterParam.CONTROL]: [CAPABILITY.CAN_VIEW_CONTROLS],
  [FilterParam.ASSOCIATED_RISK]: [CAPABILITY.CAN_VIEW_RISKS],
  [FilterParam.DEPARTMENT]: [CAPABILITY.CAN_VIEW_DEPARTMENTS],
  [FilterParam.OWNER]: [CAPABILITY.CAN_VIEW_USERS],
  [FilterParam.ASSIGNEE]: [CAPABILITY.CAN_VIEW_USERS],
  [FilterParam.ACTIVITY_ACTOR]: [CAPABILITY.CAN_VIEW_USERS],
  [FilterParam.AUDITOR]: [CAPABILITY.CAN_VIEW_USERS],
  [FilterParam.ACCESS_ROLE]: [CAPABILITY.CAN_VIEW_ACCESS_ROLES],
  [FilterParam.SERVICE]: [CAPABILITY.CAN_VIEW_SERVICES],
  [FilterParam.RECEPTOR]: [CAPABILITY.CAN_VIEW_RECEPTORS],
  [FilterParam.DOCUMENT_MANAGEMENT_SYSTEM]: [CAPABILITY.CAN_VIEW_RECEPTORS],
  [FilterParam.WORKFLOW_MANAGEMENT_SYSTEM]: [CAPABILITY.CAN_VIEW_RECEPTORS],
  [FilterParam.GRC_PLATFORM]: [CAPABILITY.CAN_VIEW_RECEPTORS],
  [FilterParam.FOLDER_SCAN]: [CAPABILITY.CAN_VIEW_EVIDENCE],
  [FilterParam.AUDIT]: [CAPABILITY.CAN_VIEW_AUDITS],
  [FilterParam.AUDIT_FRAMEWORKS]: [CAPABILITY.CAN_VIEW_FRAMEWORKS],
  [FilterParam.COMPLIANCE_FRAMEWORK]: [CAPABILITY.CAN_VIEW_FRAMEWORKS],
  [FilterParam.SECTION]: [CAPABILITY.CAN_VIEW_FRAMEWORKS],
  [FilterParam.RISK_CATEGORY]: [CAPABILITY.CAN_VIEW_RISK_CATEGORIES],
  [FilterParam.QUESTIONNAIRE_VENDOR]: [CAPABILITY.CAN_VIEW_VENDORS],
  [FilterParam.QUESTIONNAIRE_ASSIGNEE]: [CAPABILITY.CAN_VIEW_USERS],
  [FilterParam.AUDIT_RUN_OWNER]: [CAPABILITY.CAN_VIEW_USERS],
  [FilterParam.AUDIT_RUN_CONTROL]: [CAPABILITY.CAN_VIEW_CONTROLS],
  [FilterParam.REPORT_PLAYBOOK]: [CAPABILITY.CAN_VIEW_PLAYBOOKS],
  [FilterParam.DASHBOARD_OWNER]: [CAPABILITY.CAN_VIEW_USERS],
  [FilterParam.DASHBOARD_AUDIT]: [CAPABILITY.CAN_VIEW_AUDITS],
  [FilterParam.DASHBOARD_RISK]: [CAPABILITY.CAN_VIEW_RISKS],
  [FilterParam.DASHBOARD_DEPARTMENT]: [CAPABILITY.CAN_VIEW_DEPARTMENTS],
  [FilterParam.DASHBOARD_FRAMEWORK]: [CAPABILITY.CAN_VIEW_FRAMEWORKS],
  [FilterParam.DASHBOARD_POLICY]: [CAPABILITY.CAN_VIEW_POLICIES],
  [FilterParam.DASHBOARD_CONTROL]: [CAPABILITY.CAN_VIEW_CONTROLS],
  [FilterParam.DASHBOARD_RISK_CATEGORY]: [CAPABILITY.CAN_VIEW_RISK_CATEGORIES],
  [FilterParam.DASHBOARD_VENDOR]: [CAPABILITY.CAN_VIEW_VENDORS],
  [FilterParam.DASHBOARD_VENDOR_NAME]: [CAPABILITY.CAN_VIEW_VENDORS],
  [FilterParam.DASHBOARD_ASSIGNEE]: [CAPABILITY.CAN_VIEW_USERS],
  [FilterParam.REQUEST_CONTROLS]: [CAPABILITY.CAN_VIEW_CONTROLS],
  [FilterParam.REQUEST_EVIDENCE]: [CAPABILITY.CAN_VIEW_EVIDENCE],
  [FilterParam.REQUEST_POLICY]: [CAPABILITY.CAN_VIEW_POLICIES],
  [FilterParam.REQUEST_VENDOR]: [CAPABILITY.CAN_VIEW_VENDORS],
  [FilterParam.REQUEST_RISK]: [CAPABILITY.CAN_VIEW_RISKS],
  [FilterParam.CITATION_POLICY]: [CAPABILITY.CAN_VIEW_POLICIES],
  [FilterParam.CITATION_CONTROL]: [CAPABILITY.CAN_VIEW_CONTROLS],
  [FilterParam.CITATION_EVIDENCE]: [CAPABILITY.CAN_VIEW_EVIDENCE],
  [FilterParam.CITATION_REQUEST]: [CAPABILITY.CAN_VIEW_REQUESTS],
  [FilterParam.CITATION_RISK]: [CAPABILITY.CAN_VIEW_RISKS],
}

export const filterRequiredCapabilities = (param: string): CAPABILITY[] =>
  FILTER_REQUIRED_CAPABILITIES[param as FilterParam] || []
